export default (str) => (typeof str === 'string' && str.length > 0)
